/**
 * dashboard
 */
import graphAB from './graph001-002.js';
import graphC from './graph003.js';
import graphD from './graph004.js';
import graphE from './graph005.js';
import graphF from './graph006.js';
import graphG from './graph008.js';
import {convertToDate, getNowDateWithString} from "../../../../../../frontend/src/utils/helper";

export default ((cmp, util) => {
  function getNowDateWithString(){
    var dt = new Date();
    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth()+1)).slice(-2);
    var d = ("00" + dt.getDate()).slice(-2);
    var result = y + "/" + m + "/" + d;
    return result;
  }

  function getPastDateWithString(days){
    var dt = new Date();
    dt.setDate(dt.getDate() - days)

    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth()+1)).slice(-2);
    var d = ("00" + dt.getDate()).slice(-2);
    var result = y + "/" + m + "/" + d;
    return result;
  }

  function convertToDate(dateString){
    let converted = dateString.slice(0, 10);
    return converted.replace(/-/g, "/");
  }

	// 回答モーダル::要チェック
	const voteEvent = function() {
		$('#vote-btn').click(function(){
			$.ajax({
				type: "POST",
				url: '/ajax/vote/' + $(this).data('id'),
				data: {_xsrf: _xsrf, id: $(this).data('id')},
				dataType: 'json',
				timeout: 10000
			}).done(function (data) {
				if(data.status == 'add') {
					$('.vote-count-' + data.id).each(function() {
						var c = parseInt($(this).text()) + 1;
						$(this).text( c );
						$(this).closest('div').find('.svg-star-dims').html(
							c > 0 ? '<use xlink:href="/assets/img/shared/sprite.symbol.svg#star"></use>' : '<use xlink:href="/assets/img/shared/sprite.symbol.svg#star_line"></use>'
						);
						$(this).closest('div').find('i').addClass('animate__star--bounceIn');
					});
				} else {
					$('.vote-count-' + data.id).each(function() {
						var c = Math.max(0, parseInt($(this).text()) - 1);
						$(this).text( c );
						$(this).closest('div').find('.svg-star-dims').html(
							c > 0 ? '<use xlink:href="/assets/img/shared/sprite.symbol.svg#star"></use>' : '<use xlink:href="/assets/img/shared/sprite.symbol.svg#star_line"></use>'
						);
						$(this).closest('div').find('i').removeClass('animate__star--bounceIn');
					});
				}

				reloadAnswers();
			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
				console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
				console.log("errorThrown: " + errorThrown.message); // 例外情報
				util.checkSession(jqXHR);
			});
		});
	};

	// 回答モーダル::削除
	const deleteEvent = function() {
		$('.answer-delete-btn').click(function(){
			$.ajax({
				type: "POST",
				url: '/survey/answer_delete/' + $(this).data('id'),
				dataType: 'json',
				timeout: 20000,
				data: {_xsrf: _xsrf, id: $(this).data('id')}
			}).done(function (data) {

				reloadAnswers();

			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
				console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
				console.log("errorThrown: " + errorThrown.message); // 例外情報
				util.checkSession(jqXHR);
			});
		});
	};

	// 回答モーダル監視とイベント
	const modalObs = util.observer($('#js-modal--white__body').get(0), function() {
		// 要チェック
		voteEvent();
		// 削除ボタン
		deleteEvent();
		// print
		util.print();
	});

	// 回答一覧再読み込み
	const reloadAnswers = async function() {

		await new Promise((resolve) => {
			setTimeout(() => { $('.js-modal--white__button:eq(0)').click(); resolve(console.log('gG')); }, 460);
		});

		await new Promise((resolve) => {
			setTimeout(() => { gAB(false, true); resolve(console.log('gAB')); }, 120);
		});
		await new Promise((resolve) => {
			setTimeout(() => { gG(false, true); resolve(console.log('gG')); }, 240);
		});
	};

	// graph 1,2 --------------------------------------------
	const gAB = function(check, clear) {
		if(!clear) cmp.loading('データ分析に少し時間がかかります');
		cmp.working('#inc-dashboard', '読み込み中');
		if(check !== false) util.checkSession();

		$.ajax({
			type: 'POST',
			url: '/ajax/dashboard/' + currentView.survey_id + '/' + currentView.office_id,
			dataType: 'json',
			timeout: 42000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to, clear: clear ? 1 : ''}
		}).done(function(data) {

			var doc = $(data.html);
			$('#inc-dashboard').replaceWith(data.html);
			doc.ready(function() {
				const G001 = new graphAB('#g001', [ data.nps.office.low, data.nps.office.midium, data.nps.office.high ]);
				const G001_1 = new graphAB('#g001_1', [ data.nps.office.low, data.nps.office.midium, data.nps.office.high ]);
				const G002 = new graphAB('#g002', [ data.nps.all.low, data.nps.all.midium, data.nps.all.high ], "small");
				const G002_1 = new graphAB('#g002_1', [ data.nps.all.low, data.nps.all.midium, data.nps.all.high ], "small");

				$('#inc-dashboard').find('.js-modal--white__button').each(function(){
					cmp.modal($(this));
					$(this).children().click(function(e){
						$(this).closest('.js-modal--white__button').click();
						e.stopPropagation();
					});
				});

				cmp.smoothLink(); // link
				cmp.loading('DONE', true); // close
			});

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);

      cmp.loading('DONE', true); // close
		});
	};
	// ------------------------------------------------------

	// graph 3 ----------------------------------------------
	const gC = function(check) {
		if(check !== false) util.checkSession();
		$.ajax({
			type: "POST",
			url: '/ajax/npschart/' + currentView.survey_id + '/' + currentView.office_id + '/'+ currentView.organization_id,
			dataType: 'json',
			timeout: 100000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to}
		}).done(function(data) {

			const G003_1 = new graphC(
				'#g003', { data1: data.d.score, data2: data.d.score, x: data.d.span }, ''
			);
			const G003_2 = new graphC(
				'#g003-week', { data1: data.w.score, data2: data.w.score, x: data.w.span }, 'g3-w'
			);
			const G003_3 = new graphC(
				'#g003-month', { data1: data.m.score, data2: data.m.score, x: data.m.span }, 'g3-m'
			);

			cmp.working('#inc-npschart', '', true);

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------

	// graph 4 ----------------------------------------------
	const gD = function(check) {
		if(check !== false) util.checkSession();
		$.ajax({
			type: "POST",
			url: '/ajax/npschartdetail/' + currentView.survey_id + '/' + currentView.office_id + '/' + currentView.organization_id,
			dataType: 'json',
      timeout: 100000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to}
		}).done(function (data) {

			const G004_1 = new graphD(
				'#g004', { good: data.d.good, normal: data.d.neutral, bad: data.d.bad, x: data.d.span, max: data.d.max }, ''
			);
			const G004_2 = new graphD(
				'#g004-week', { good: data.w.good, normal: data.w.neutral, bad: data.w.bad, x: data.w.span, max: data.w.max }, 'g4-w'
			);
			const G004_3 = new graphD(
				'#g004-month', { good: data.m.good, normal: data.m.neutral, bad: data.m.bad, x: data.m.span, max: data.m.max }, 'g4-m'
			);

			cmp.working('#inc-npschart', '', true);

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------

	// graph 5 ----------------------------------------------
	const gE = function(check) {
		cmp.working('#inc-analysis', '読み込み中');
		if(check !== false) util.checkSession();

		$.ajax({
			type: "POST",
			url: '/ajax/analysis/' + currentView.survey_id + '/' + currentView.office_id + '/' + currentView.organization_id,
			dataType: 'json',
			timeout: 42000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to}
		}).done(function(data) {

			var doc = $(data.html);
			$('#inc-analysis').replaceWith(data.html);
			doc.ready(function() {

				const G005 = new graphE('#g005', data.data);

				// 表示非表示ボタン
				$('.dot-toggle-btn').click(function(){
					$(this).toggleClass('c-btn-tag--active');
					var i = $('.dot-toggle-btn').index(this);
					$('.svgDot .dot:eq(' +i+ '), .svgDot circle:eq(' +i+ ')').toggle();
				});
				$('.dot-toggle-btn').hover(
					function() {
						var i = $('.dot-toggle-btn').index(this);
						$('.svgDot .dot:eq(' +i+ ')').css('fill', '#FC74DF');
					},
					function() {
						var i = $('.dot-toggle-btn').index(this);
						$('.svgDot .dot:eq(' +i+ ')').css('fill', 'rgb(12, 217, 226)');
					}
				);
			});

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------

	// graph 6 ----------------------------------------------
	const gF = function(check) {
		cmp.working('#a001-survey-total-1', '読み込み中');
		if(check !== false) util.checkSession();

		$.ajax({
			type: "POST",
			url: '/ajax/surveygraph/' + currentView.survey_id + '/' + currentView.office_id + '/' + ($('#a001-survey-total-1-01').val() ? $('#a001-survey-total-1-01').val() : '0') + '/' + currentView.organization_id,
			dataType: 'json',
			timeout: 42000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to}
		}).done(function(data) {

			var doc = $(data.html);
			$('#a001-survey-total-1').replaceWith(data.html);
			doc.ready(function() {

				cmp.selectBox('#a001-survey-total-1 select', function() {
					util.checkSession();
					gF();
				});
				cmp.tabs('.sum-cross-tab');

				const G006 = new graphF('#g006', data.data);
			});

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------

	// without graph 7 ----------------------------------------------
	const gX = function(check) {
		cmp.working('#a001-survey-total-2', '読み込み中');
		if(check !== false) util.checkSession();

		$.ajax({
			type: "POST",
			url: '/ajax/surveygraph2/' + currentView.survey_id + '/' + currentView.office_id + '/' + ($('#a001-survey-total-2-01').val() ? $('#a001-survey-total-2-01').val() : '0') + '/' + ($('#a001-survey-total-2-02').val() ? $('#a001-survey-total-2-02').val() : '0') + '/' + currentView.organization_id,
			dataType: 'json',
			timeout: 42000,
			data: {_xsrf:_xsrf, from:currentView.date_from, to:currentView.date_to}
		}).done(function(data) {

			var doc = $(data.html);
			$('#a001-survey-total-2').replaceWith(data.html);
			doc.ready(function() {

				cmp.selectBox('#a001-survey-total-2 select', function() {
					util.checkSession();
					gX();
				});

				cmp.tabs('.sum-cross-tab');
			});

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------
  console.log('test');
	// graph 8 ----------------------------------------------
	const gG = function(check, clear) {
		cmp.working('#a001-survey-list', '読み込み中');
		if(check !== false) util.checkSession();

		$.ajax({
			type: "POST",
			url: '/ajax/survey/' + currentView.survey_id + '/' + currentView.office_id + '/'+currentView.organization_id,
			dataType: 'json',
			timeout: 42000,
			data: {
				_xsrf:_xsrf,
				from: currentView.date_from,
				to: currentView.date_to,
				p: currentView.fb_page,
				sort: currentView.fb_sort,
				order: currentView.fb_order,
				clear: clear ? 1 : ''
			}
		}).done(function (data) {

			var doc = $(data.html);
			$('#a001-survey-list').replaceWith(data.html);
			doc.ready(function() {

				// graph
				const G008 = new graphG('#g008_1', {data: data.data.data, x: data.data.span});

				// paging
				$('.c-form--pagination-page a,.c-form--pagination-prev a,.c-form--pagination-next a').click(function(){
					if($(this).closest('li').hasClass('disabled')) return false;
					currentView.fb_page = $(this).data('p');
					$('.anchor-pageing').click(); // リスト上部へ
					gG();
					return false;
				});

				// sort
				$('.sort-btn').click(function(){
					currentView.fb_page = 1;
					currentView.fb_sort = $(this).data('sort');
					currentView.fb_order = currentView.fb_order == 'asc' ? 'desc' : 'asc';
					$('.anchor-pageing').click(); // リスト上部へ
					gG();
				});

				// CSV ex
				$('#csv-export').click(function(){
					location.href = '/survey/exportcsv/' + currentView.survey_id + '/' + currentView.office_id + '?from=' + encodeURIComponent(currentView.date_from) + '&to=' + encodeURIComponent(currentView.date_to);
				});

				// CSV in
				cmp.modal('.import-modal'); // モーダル準備
				$('input[name="file"]').on('change', function(){
					if(!$('input[name="file"]').val()) return false;
					cmp.messageDone('保存しています');

					var fd = new FormData();
					fd.append('file', $(this).prop('files')[0]);
					fd.append('_xsrf', _xsrf);

					$.ajax({
						type: "POST",
						url: '/survey/importcsv/' + currentView.survey_id + '/' + currentView.office_id,
						data: fd,
						processData: false,
						contentType: false,
						timeout: 1000*60*3
					}).done(function(data){
						$('.import-modal').click();
						var doc = $(data);
						doc.ready(function() {
							$('#js-modal__body').html(data);
							$('input[name="file"]').val('');
							cmp.messageDone('', true); // close
						});
					}).fail(function(jqXHR, textStatus, errorThrown){
						console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
						console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
						console.log("errorThrown: " + errorThrown.message); // 例外情報
						util.checkSession(jqXHR);
						alert('エラー');
					});
				});

				// answer modal
				$('#a001-survey-list').find('.js-modal--white__button').each(function(){
					cmp.modal($(this));
					$(this).children().click(function(e){
						$(this).closest('.js-modal--white__button').click();
						e.stopPropagation();
					});
				});

			}); // ready

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外
			util.checkSession(jqXHR);
		});
	};
	// ------------------------------------------------------

	// タブ（集計のタブを除く）
	cmp.tabs('.c-tabs:not(.sum-cross-tab)');

	// ヘッダナビイベント
	const setCurrent = async function() {
    let jqxhr;
    await new Promise(resolve => {
      if (jqxhr) {
        jqxhr.abort();
      }
			// window.stop();
			util.checkSession();
			resolve();
		});

		await new Promise(resolve => {
			cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');
			currentView.survey_id = $('select[name="survey"]').val();
      currentView.organization_id = $('select[name="organization"]').val();
			currentView.office_id = $('select[name="office"]').val();
			currentView.date_from = $('input[name="daterange"]').val().split(' - ')[0];
			currentView.date_to = $('input[name="daterange"]').val().split(' - ')[1];
			currentView.fb_page = 1;

			localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("officeId", currentView.office_id);
      localStorage.setItem("organizationId", currentView.organization_id);
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

			resolve();
		});

    if(currentView.survey_id) {
      await new Promise((resolve) => {
        setTimeout(() => {
          gAB(false);
          resolve(console.log('gAB'));
        }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          gE(false);
          resolve(console.log('gE'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gF(false);
          resolve(console.log('gF'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gG(false);
          resolve(console.log('gG'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gX(false);
          resolve(console.log('gX'));
        }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => {
          gC(false);
          resolve(console.log('gC'));
        }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gD(false);
          resolve(console.log('gD'));
        }, 420);
      });
    }else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
	};

  // ヘッダナビイベント
  const setCurrentOrganization = async function() {
    let jqxhr;
    await new Promise(resolve => {
      if (jqxhr) {
        jqxhr.abort();
      }
      // window.stop();
      util.checkSession();
      resolve();
    });

    await new Promise(resolve => {
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');
      currentView.survey_id = $('select[name="survey"]').val();
      currentView.organization_id = $('select[name="organization"]').val();
      currentView.office_id = "-1";
      currentView.date_from = $('input[name="daterange"]').val().split(' - ')[0];
      currentView.date_to = $('input[name="daterange"]').val().split(' - ')[1];
      currentView.fb_page = 1;

      localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("officeId", "-1");
      localStorage.setItem("organizationId", currentView.organization_id);
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

      resolve();
    });

    if(currentView.survey_id) {
      await new Promise((resolve) => {
        setTimeout(() => {
          gAB(false);
          resolve(console.log('gAB'));
        }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          gE(false);
          resolve(console.log('gE'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gF(false);
          resolve(console.log('gF'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gG(false);
          resolve(console.log('gG'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gX(false);
          resolve(console.log('gX'));
        }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => {
          gC(false);
          resolve(console.log('gC'));
        }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gD(false);
          resolve(console.log('gD'));
        }, 420);
      });
    }else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
  };

	// SPヘッダナビイベント
	const setCurrentSP = async function() {
		await new Promise(resolve => {
			// window.stop();
			util.checkSession();
			resolve();
		});

		await new Promise(resolve => {
			cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');
			currentView.survey_id = $('select[name="survey_sp"]').val();
      currentView.organization_id = $('select[name="organization_sp"]').val();
			currentView.office_id = $('select[name="office_sp"]').val();
			currentView.date_from = $('input[name="daterange_sp"]').val().split(' - ')[0];
			currentView.date_to = $('input[name="daterange_sp"]').val().split(' - ')[1];
			currentView.fb_page = 1;

      localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("organizationId",currentView.organization_id);
      localStorage.setItem("officeId", currentView.office_id);
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

      resolve();
		});

		if(currentView.survey_id){
      await new Promise((resolve) => {
        setTimeout(() => { gAB(false); resolve(console.log('gAB')); }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => { gE(false); resolve(console.log('gE')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gF(false); resolve(console.log('gF')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gG(false); resolve(console.log('gG')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gX(false); resolve(console.log('gX')); }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => { gC(false); resolve(console.log('gC')); }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gD(false); resolve(console.log('gD')); }, 420);
      });
    } else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
	};

  // SPヘッダナビイベント
  const setCurrentOrganizationSP = async function() {
    await new Promise(resolve => {
      // window.stop();
      util.checkSession();
      resolve();
    });

    await new Promise(resolve => {
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');
      currentView.survey_id = $('select[name="survey_sp"]').val();
      currentView.organization_id = $('select[name="organization_sp"]').val();
      currentView.office_id = "-1";
      currentView.date_from = $('input[name="daterange_sp"]').val().split(' - ')[0];
      currentView.date_to = $('input[name="daterange_sp"]').val().split(' - ')[1];
      currentView.fb_page = 1;

      localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("organizationId",currentView.organization_id);
      localStorage.setItem("officeId", "-1");
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

      resolve();
    });

    if(currentView.survey_id){
      await new Promise((resolve) => {
        setTimeout(() => { gAB(false); resolve(console.log('gAB')); }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => { gE(false); resolve(console.log('gE')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gF(false); resolve(console.log('gF')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gG(false); resolve(console.log('gG')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gX(false); resolve(console.log('gX')); }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => { gC(false); resolve(console.log('gC')); }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gD(false); resolve(console.log('gD')); }, 420);
      });
    } else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
  };

  // ヘッダナビイベント（アンケート変更）
  const setCurrentSurvey = async function() {
    let jqxhr;
    await new Promise(resolve => {
      if (jqxhr) {
        jqxhr.abort();
      }
      // window.stop();
      util.checkSession();
      resolve();
    });

    await new Promise(resolve => {
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');

      currentView.survey_id = $('select[name="survey"]').val();
      currentView.organization_id = $('select[name="organization"]').val();
      currentView.office_id = $('select[name="office"]').val();
      currentView.fb_page = 1;

      const surveys = localStorage.getItem("surveys") ? JSON.parse(localStorage.getItem("surveys")) : [];
      if (surveys.length > 0){
        console.log(surveys);
        console.log(currentView);
        const currentSurvey = surveys.find(survey => survey.id === Number(currentView.survey_id));
        console.log(currentSurvey);

        const today = getNowDateWithString();
        let dateStart = currentSurvey.started_at ? convertToDate(currentSurvey.started_at) : convertToDate(currentSurvey.created_at);
        let dateEnd = currentSurvey.ended_at ? convertToDate(currentSurvey.ended_at) : today;

        if(Number(currentView.survey_id) === 282){
          dateStart = "2020/03/12";
          dateEnd = "2020/05/11";
          cmp.calendar('input[name="daterange"]', true, dateStart, dateEnd);
        }else{
          cmp.calendar('input[name="daterange"]', true, false, false);
        }
        currentView.date_from = dateStart;
        currentView.date_to = dateEnd;
        $('input[name="daterange"]').val(currentView.date_from + " - " + currentView.date_to);
        $('input[name="daterange_sp"]').val(currentView.date_from + " - " + currentView.date_to);
      }

      localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("organizationId",currentView.organization_id);
      localStorage.setItem("officeId", currentView.office_id);
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

      resolve();
    });

    if(currentView.survey_id) {
      await new Promise((resolve) => {
        setTimeout(() => {
          gAB(false);
          resolve(console.log('gAB'));
        }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          gE(false);
          resolve(console.log('gE'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gF(false);
          resolve(console.log('gF'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gG(false);
          resolve(console.log('gG'));
        }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gX(false);
          resolve(console.log('gX'));
        }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => {
          gC(false);
          resolve(console.log('gC'));
        }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          gD(false);
          resolve(console.log('gD'));
        }, 420);
      });
    }else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
  };

  // SPヘッダナビイベント（アンケート変更）
  const setCurrentSurveySP = async function() {
    await new Promise(resolve => {
      // window.stop();
      util.checkSession();
      resolve();
    });

    await new Promise(resolve => {
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '読み込み中');

      currentView.survey_id = $('select[name="survey_sp"]').val();
      currentView.organization_id = $('select[name="organization_sp"]').val();
      currentView.office_id = $('select[name="office_sp"]').val();
      currentView.fb_page = 1;

      const surveys = localStorage.getItem("surveys") ? JSON.parse(localStorage.getItem("surveys")) : [];
      if (surveys.length > 0){
        const currentSurvey = surveys.find(survey => survey.id === Number(currentView.survey_id));

        const today = getNowDateWithString();
        let dateStart = currentSurvey.started_at ? convertToDate(currentSurvey.started_at) : convertToDate(currentSurvey.created_at);
        let dateEnd = currentSurvey.ended_at ? convertToDate(currentSurvey.ended_at) : today;

        if(Number(currentView.survey_id) === 282){
          dateStart = "2020/03/12";
          dateEnd = "2020/05/11";
          cmp.calendar('input[name="daterange_sp"]', true, dateStart, dateEnd);
        }else{
          cmp.calendar('input[name="daterange_sp"]', true, false, false);
        }
        currentView.date_from = dateStart;
        currentView.date_to = dateEnd;
        $('input[name="daterange"]').val(currentView.date_from + " - " + currentView.date_to);
        $('input[name="daterange_sp"]').val(currentView.date_from + " - " + currentView.date_to);
      }

      localStorage.setItem("surveyId",currentView.survey_id);
      localStorage.setItem("organizationId",currentView.organization_id);
      localStorage.setItem("officeId", currentView.office_id);
      localStorage.setItem("dateStart", JSON.stringify(currentView.date_from));
      localStorage.setItem("dateEnd", JSON.stringify(currentView.date_to));

      resolve();
    });

    if(currentView.survey_id){
      await new Promise((resolve) => {
        setTimeout(() => { gAB(false); resolve(console.log('gAB')); }, 120);
      });

      await new Promise((resolve) => {
        setTimeout(() => { gE(false); resolve(console.log('gE')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gF(false); resolve(console.log('gF')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gG(false); resolve(console.log('gG')); }, 360);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gX(false); resolve(console.log('gX')); }, 360);
      });

      // 以下2つが遅い
      await new Promise((resolve) => {
        setTimeout(() => { gC(false); resolve(console.log('gC')); }, 420);
      });
      await new Promise((resolve) => {
        setTimeout(() => { gD(false); resolve(console.log('gD')); }, 420);
      });
    } else{
      cmp.working('#inc-analysis,#inc-npschart,#inc-dashboard,#a001-survey-total-1,#a001-survey-total-2,#a001-survey-list', '', true);
    }
  };

  // ヘッダナビ
  let minDate = false;
  let maxDate = false;
  if(currentView.survey_id === 282){
    minDate = '2020/03/12';
    maxDate = '2020/05/11';
  }
  const organizationListSelect = document.querySelector("select[name='organization']");
  const organizationState = JSON.parse(localStorage.getItem('organizations'));
  organizationState.forEach(organization => {
    const element = document.createElement('option');
    element.innerHTML = organization.text;
    element.value = organization.id;
    if(organization.id === currentView.organization_id){
      element.selected = true;
    }
    organizationListSelect.appendChild(element);
  });

  const officeListSelect = document.querySelector("select[name='office']");
  const newOfficeOptions = [];
  for(var i = 0; i < officeListSelect.options.length; i++) {
    if(currentView.readableShopIds.includes(Number(officeListSelect.options[i].value))){
      newOfficeOptions.push(officeListSelect.options[i]);
    }
  }
  officeListSelect.innerHTML = '';
  newOfficeOptions.forEach(option=>{
    officeListSelect.appendChild(option);
  })

  cmp.selectBox('select[name="survey"]', setCurrentSurvey);
  cmp.selectBox('select[name="office"]', setCurrent);
  cmp.selectBox('select[name="organization"]', setCurrentOrganization);
  cmp.calendar('input[name="daterange"]', true, minDate, maxDate);
	$('input[name="daterange"]').change(setCurrent);

	// ヘッダナビSP
	cmp.sphnav('.collapsible');
	cmp.selectBox('select[name="survey_sp"]', setCurrentSurveySP);
  cmp.selectBox('select[name="office_sp"]', setCurrentSP);
  cmp.selectBox('select[name="organization_sp"]', setCurrentOrganizationSP);
  cmp.calendar('input[name="daterange_sp"]', true, minDate, maxDate);
	$('input[name="daterange_sp"]').change(setCurrentSP);

	// ページ内リンク
	cmp.smoothLink();

	// graph init
  if($('select[name="survey"]').val()){
    $('input[name="daterange"]').val(currentView.date_from + " - " + currentView.date_to);
    $('input[name="daterange_sp"]').val(currentView.date_from + " - " + currentView.date_to);

    setCurrent();
  }
});
